import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ScheduleClient } from "../../web-api-client";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { appConfig } from "../../appconfig";

export type TimeRangeStatusPayload = {
  clinicId: number;
  localDate: string;  // "yyyy-MM-dd"
  startTime: string;  // "HH:mm"
  endTime: string;    // "HH:mm"
  status: "O" | "C";
};

export function useUpdateTimeRangeStatus() {
  const qc = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (payload: TimeRangeStatusPayload) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });

      return client.updateTimeRangeStatus(payload as any);
    },

    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["schedules"] });
    },
  });
}